import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  beforeRouteEnter(to: any, from: any, next: (vm?: any) => void) {
    next((vm: any) => {
      let path = to.path;
      if (path[0] === "/") {
        path = path.substr(1);
      }
      if (vm.activedMenuPath !== path) {
        vm.activedMenuPath = path;
      }
      if (to.matched && to.matched.length === 3) {
        vm.activedMenuPath = to.matched[1].path.replace("/", "");
      }
    });
  },

  beforeRouteUpdate(to: any, from: any, next: () => void) {
    let path = to.path;
    if (path[0] === "/") {
      path = path.substr(1);
    }
    const vm = this as any;
    if (vm.activedMenuPath !== path) {
      vm.activedMenuPath = path;
    }
    if (to.matched && to.matched.length === 3) {
      vm.activedMenuPath = to.matched[1].path.replace("/", "");
    }
    next();
  },

  data() {
    return {
      activedMenuPath: "monitor",
    };
  },
};

import { computed, watch } from "vue";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { useStore } from "@/stores";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'HomePage',
  setup(__props) {

const store = useStore();

const appTitle = computed(() => store.getters.appTitle);

const userEntity = computed(() => store.getters["user/user"] || {});

const userName = computed(() => userEntity.value.name);

const taskId = window.localStorage.getItem(`patentsync-taskid-${userEntity.value.id}`);
if (!isEmptyOrWhiteSpace(taskId)) {
  store.commit("patentsync/taskId", taskId);
}

const startPatentSync = () => {
  const syncTaskId = (store.state as any).patentsync?.taskId;
  if (isEmptyOrWhiteSpace(syncTaskId)) {
    return;
  }
  return store.dispatch("patentsync/queryProgress");
};

watch(
  () => (store.state as any).patentsync?.taskId,
  () => startPatentSync()
);

const logout = () => {
  store.dispatch("user/logout").then(() => router.push("login"));
};

const onUserInfoCommand = (cmd: string) => {
  if (cmd === "logout") {
    logout();
  }
};

return { __sfc: true,store, appTitle, userEntity, userName, taskId, startPatentSync, logout, onUserInfoCommand }
}

})